import * as yup from 'yup'
import { REGEX_SPECIAL_CHARACTER, REGEX_EMAIL, REGEX_SPECIAL_CHARACTER_ALLOWED } from '~/constants'
import { resetValidateMessage, validateMessage } from '~/resources/validate-message'
import { getPasswordValidationSchema, getResetPasswordValidationSchema } from '~/validate/forms/common'
import { AUTH_CRITERIA } from '~/validate/constant/auth'

export const formLoginSchema = yup.object().shape({
  username: yup
    .string()
    .required('Vui lòng nhập tên đăng nhập.')
    .min(AUTH_CRITERIA.USER_NAME_MIN_LENGTH, validateMessage.min)
    .max(AUTH_CRITERIA.USER_NAME_MAX_LENGTH, validateMessage.max)
    .matches(new RegExp(REGEX_SPECIAL_CHARACTER_ALLOWED), validateMessage.usernameSpecialChars),
  password: yup
    .string()
    .required('Vui lòng nhập mật khẩu.')
    .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, validateMessage.passwordValidate)
    .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.max)
})

export const formRegisterSchema = yup.object().shape({
  username: yup
    .string()
    .required('Vui lòng nhập tên đăng nhập.')
    .min(AUTH_CRITERIA.USER_NAME_MIN_LENGTH, validateMessage.min)
    .max(AUTH_CRITERIA.USER_NAME_MAX_LENGTH, validateMessage.max)
    .matches(
      new RegExp(REGEX_SPECIAL_CHARACTER),
      'Tên đăng nhập không chứa ký tự đặc biệt, ký tự có dấu hoặc khoảng trắng'
    ),
  displayName: yup.lazy((value: string) => {
    if (!value || value.trim() === '') {
      return yup.string()
    }
    return yup
      .string()
      .min(AUTH_CRITERIA.DISPLAY_NAME_MIN_LENGTH, validateMessage.min)
      .max(AUTH_CRITERIA.DISPLAY_NAME_MAX_LENGTH, validateMessage.max)
      .matches(new RegExp(REGEX_SPECIAL_CHARACTER), 'Tên hiển thị viết liền không dấu')
      .test('not-username', 'Tên hiển thị là duy nhất và không trùng với tên đăng nhập.', function (value) {
        const username: string = this.parent.username.toLowerCase() || ''
        return username !== value.toLowerCase()
      })
  }),
  password: getPasswordValidationSchema(),
  passwordConfirm: yup.lazy((value: string, { parent }) => {
    const password = parent.password
    if (!password) {
      return yup.string().required('Vui lòng nhập mật khẩu.')
    }
    if (!value || value.trim() === '') {
      return yup.string().required('Vui lòng xác nhận mật khẩu.')
    }
    return yup
      .string()
      .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, validateMessage.min)
      .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.max)
      .oneOf([yup.ref('password')], 'Xác nhận mật khẩu mới không trùng khớp')
  }),
  phone: yup
    .string()
    .required('Xin hãy nhập số điện thoại của bạn.')
    .min(AUTH_CRITERIA.PHONE_MIN_LENGTH, 'Vui lòng không nhập ít hơn 10 ký tự.')
    .test('starts-with-0', 'Số điện thoại bắt đầu bằng số 0', val => val.startsWith('0'))
})

export const formWelcomeBackSchema = yup.object().shape({
  password: yup
    .string()
    .required('Vui lòng nhập mật khẩu.')
    .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, validateMessage.min)
    .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.max)
})

export const formForgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .required('Vui lòng nhập email.')
    .matches(new RegExp(REGEX_EMAIL), 'Email không hợp lệ.')
    .email('Email không hợp lệ.')
    .max(AUTH_CRITERIA.EMAIL_MAX_LENGTH, 'Vui lòng không nhập quá 50 ký tự.')
})

export const formResetPasswordSchema = yup.object().shape({
  newPassword: getResetPasswordValidationSchema(),
  passwordConfirm: yup.lazy((value: string) => {
    if (!value || value.trim() === '') {
      return yup.string().required('Vui lòng xác nhận mật khẩu.')
    }
    return yup
      .string()
      .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, resetValidateMessage.min)
      .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.max)
      .oneOf([yup.ref('newPassword')], 'Xác nhận mật khẩu mới không trùng khớp')
  })
})
